//アンカーリンク
function scrollToTarget(target, duration) {

	const targetElement = document.querySelector(target);
	const targetPosition = targetElement.offsetTop;
	const startPosition = window.pageYOffset;
	const distance = targetPosition - startPosition;
	const startTime = performance.now();

	function scrollAnimation(currentTime) {
		const timeElapsed = currentTime - startTime;
		const progress = Math.min(timeElapsed / duration, 1);
		const easing = easeInOutQuad(progress);
		window.scrollTo(0, startPosition + distance * easing);

		if (timeElapsed < duration) {
			window.requestAnimationFrame(scrollAnimation);
		}
	}

	function easeInOutQuad(t) {
		return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	}

	window.requestAnimationFrame(scrollAnimation);
}

//会員ページでなければ、アンカーリンクをスムーススクロールに
//商品詳細ページでなければ(バリアントボタンエリアがなければ)、アンカーリンクをスムーススクロールに
const customer = document.querySelector('.customer');
const cmorg = document.querySelector('.cmorg');
if (customer == null && cmorg == null) {
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();
			const target = this.getAttribute('href');
			const duration = 500; // アニメーションの時間（ミリ秒）
			scrollToTarget(target, duration);
		});
	});
}

const pagetopBtn = document.getElementById('pagetopBtn');
window.addEventListener('scroll', function () {
	var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollPosition > 150) {
		pagetopBtn.classList.add('is-active');
	} else {
		pagetopBtn.classList.remove('is-active');
	}
});


//BLOG
const BlogTagFilter = document.getElementById('BlogTagFilter');
if (BlogTagFilter != null) {
	BlogTagFilter.addEventListener('change', function (e) {
		location.href = location.origin + '/' + e.target.value;
	}, false);
}

//外部リンク
const links = document.querySelectorAll('a');
for (let i = 0; i < links.length; i++) {
	if (links[i].hostname !== window.location.hostname) {
		links[i].target = '_blank';
		links[i].rel = 'noreferrer noopener';
	}
}
